import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import("@/views/StartSeite.vue"),
    meta: { title: "Startseite | Tanzakademie Clemens" },
  },
  {
    path: "/kontakt",
    component: () => import("@/views/Kontakt.vue"),
    meta: { title: "Kontakt | Tanzakademie Clemens" },
  },
  {
    path: "/kurse",
    component: () => import("@/views/Kurse.vue"),
    meta: { title: "Kurse | Tanzakademie Clemens" },
  },
  {
    path: "/probetraining",
    component: () => import("@/views/probeTraining.vue"),
    meta: { title: "Probetraining | Tanzakademie Clemens" },
  },
  {
    path: "/stundenplan",
    component: () => import("@/views/Stundenplan.vue"),
    meta: { title: "Stundenplan | Tanzakademie Clemens" },
  },
  {
    path: "/preise",
    component: () => import("@/views/Preise.vue"),
    meta: { title: "Preise | Tanzakademie Clemens" },
  },
  {
    path: "/aktuelles",
    component: () => import("@/views/AktuelleInfo.vue"),
    meta: { title: "Aktuelles | Tanzakademie Clemens" },
  },
  {
    path: "/info",
    component: () => import("@/views/AboutUs.vue"),
    meta: { title: "Über Uns | Tanzakademie Clemens" },
  },
  {
    path: "/bilder",
    component: () => import("@/views/GalerieBilder.vue"),
    meta: { title: "Bildergalerie | Tanzakademie Clemens" },
  },
  {
    path: "/impressum",
    component: () => import("@/views/ImpressumSeite.vue"),
    meta: { title: "Impressum | Tanzakademie Clemens" },
  },
  {
    path: "/datenschutz",
    component: () => import("@/views/DatenSchutz.vue"),
    meta: { title: "Datenschutzerklärung | Tanzakademie Clemens" },
  },
  {
    path: "/links",
    component: () => import("@/views/LinkSeite.vue"),
    meta: { title: "Externe Links | Tanzakademie Clemens" },
  },
  {
    path: "/standorte",
    component: () => import("@/views/NavigatorPage.vue"),
    meta: { title: "Standorte | Tanzakademie Clemens" },
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/views/NotFound.vue"),
    meta: { title: "Seite nicht gefunden | Tanzakademie Clemens" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
});

export default router;
